/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník typů úložných jednotek zařízení.
 * @enum {string}
 */
const FileSystemType = {
  /** Úložná jednotka, která je vnitřní součástí zařízení. */
  Internal: 'internal',
  /** Úložiště rozšířené pomocí SD karty. */
  SdCard: 'sdcard',
  /** Úložiště rozšířené pomocí USB. */
  Usb: 'usb'
};

export default FileSystemType;
